import type { Sport } from '@/views/ValueDashboard/types';
import { marketStaleAfterMs } from './marketLifecycle';

export type MarketFreshness = 'fresh' | 'stale' | 'unknown';

export interface MarketFreshnessInput {
  /** Milliseconds since the freshest evidence for this ticker — the older of
   *  the browser observation stamp and the producer's own lastUpdateMs. Null
   *  when the market has never been seen; that reads as 'unknown', not fresh. */
  ageMs: number | null;
  sport: Sport | string | null;
  gameState: 'live' | 'pre' | 'final';
}

/** Classify a market without reading the store or the wall clock. */
export function classifyMarketFreshness(input: MarketFreshnessInput): MarketFreshness {
  if (input.gameState === 'final' || input.ageMs == null) return 'unknown';
  const bound = marketStaleAfterMs(input.sport);
  if (bound == null) return 'unknown';
  return input.ageMs > bound ? 'stale' : 'fresh';
}
